import { AxiosInstance } from "axios";
import ApiClient from "./ApiClient";
import { LaunchReadiness } from "../types/Phase";

// Mentoring Fusion API base URL
const API_URL = process.env.REACT_APP_MENTORING_API_URL ?? "";

/**
 * Service for campaign phase–related endpoints (launch readiness, launch, close).
 */
class PhaseService {
  private apiClient: AxiosInstance;

  constructor() {
    this.apiClient = new ApiClient(API_URL).getClient();
  }

  /* -------------------------------------------------------------------------- */
  /*                           Launch readiness + launch                         */
  /* -------------------------------------------------------------------------- */

  /**
   * Check if a campaign can be launched.
   * GET /organizations/{org}/campaigns/{camp}/launch
   */
  public getLaunchReadiness = async (
    organizationId: string,
    campaignId: string
  ): Promise<LaunchReadiness> => {
    type ApiReadiness = {
      is_ready: boolean;
      missing_questions: boolean;
      invalid_dates: boolean;
      missing_matching_questions: boolean;
      invalid_campaign_status: boolean;
    };

    const response = await this.apiClient.get<ApiReadiness>(
      `/organizations/${organizationId}/campaigns/${campaignId}/launch`
    );

    const d = response.data;
    // Convert snake_case → camelCase
    return {
      isReady: d.is_ready,
      missingQuestions: d.missing_questions,
      invalidDates: d.invalid_dates,
      missingMatchingQuestions: d.missing_matching_questions,
      invalidCampaignStatus: d.invalid_campaign_status,
    };
  };

  /**
   * Launch a campaign (transition PREP → MATCHING).
   * POST /organizations/{org}/campaigns/{camp}/launch
   */
  public launchCampaign = async (
    organizationId: string,
    campaignId: string
  ): Promise<void> => {
    await this.apiClient.post(
      `/organizations/${organizationId}/campaigns/${campaignId}/launch`
    );
  };

  /* -------------------------------------------------------------------------- */
  /*                                 Close phase                                */
  /* -------------------------------------------------------------------------- */

  /**
   * Close a campaign (transition RUNNING → CLOSED).
   * POST /organizations/{org}/campaigns/{camp}/close
   */
  public closeCampaign = async (
    organizationId: string,
    campaignId: string
  ): Promise<void> => {
    await this.apiClient.post(
      `/organizations/${organizationId}/campaigns/${campaignId}/close`
    );
  };
}

const phaseService = new PhaseService();
export default phaseService;
